export default __webpack_public_path__ + "static/media/yellow_calendar.fcc1d0c4.svg";